import React from 'react'

export const RegContext = React.createContext()
